<template>
  <div class="site-choose">
    <div
      class="poster-wrapper"
      v-for="(logoInfo, index) of validLogos"
      :key="logoInfo.id || index"
    >
      <poster
        :id="'poster' + index"
        :size="posterData.size"
        :elConfig="posterData.elementInfo"
        :bgConfig="posterData.bgParameter"
        :elementImg="posterData.elementImg"
        :textInfo="posterData.textInfo"
        :contentStyle="posterData.contentStyle"
        :posterTextMaps="posterTextMaps"
        :portraitInfo="posterData.portraitInfo"
        :logo="logoInfo"
      />
    </div>
    <div
      class="unselect-size"
      v-if="!validLogos.length"
    >
      <span>右侧选择您需要下载的站点<br />→ → →</span>
    </div>
    <div class="choice">
      <site-choice
        @pickSite="pickSite"
        :logoOptions="logoOptions"
        :selectedSiteIds="selectedSiteIds"
      />
    </div>
    <div class="footer-panel">
      <span
        class="panel-btn"
        @click="preStep"
        >{{ schemeId ? '返回' : '上一步' }}
      </span>
      <div class="panel-right">
        <span
          v-if="schemeId"
          v-loading="isSaving"
          element-loading-spinner="el-icon-loading"
          :class="['live-btn']"
          @click="onSave(schemeId)"
        >
          覆盖原图
        </span>
        <router-link
          v-if="schemeId"
          class="live-btn"
          :to="{ name: 'posterBuild', query: { schemeId } }"
        >
          修改样式
        </router-link>
        <span
          v-loading="isSaving"
          element-loading-spinner="el-icon-loading"
          :class="['live-btn']"
          @click="onSave()"
        >
          {{ schemeId ? '另存' : '暂存设计' }}
        </span>
        <span
          :class="['panel-btn']"
          element-loading-spinner="el-icon-loading"
          @click="downLoad(schemeId)"
          v-loading="isDownLoading"
        >
          {{
            isDownLoading ? '下载中' : `暂存并下载(${validLogos.length})`
          }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import poster from "@/pages/poster/components/poster-long.vue";
import siteChoice from "@/pages/poster/components/site-choice.vue";
import store from "@/store/index";
import { mapMutations, mapState } from "vuex";
import {
  getContentStyles,
  getLogos,
  getPosterLongDetail,
  resolvePosterLogos,
  savePosterLongToBase,
  drawPosterLong,
} from "./js/poster-feature";
export default {
  name: "siteChoose",
  data() {
    return {
      // 是否正在下载
      isDownLoading: false,
      // 正在保存
      isSaving: false,
      // 设计id
      schemeId: "",
      // 内容区域的样式列表
      contentStyles: [],
      // 业务线logo
      logoOptions: [],
    };
  },
  components: {
    poster,
    siteChoice,
  },
  computed: {
    ...mapState("posterLong", ["posterData", "posterTextMaps"]),
    selectedSiteIds() {
      return this.validLogos.map(item => item.id);
    },
    validLogos() {
      return (this.posterData.logos || []).filter(
        item => item && item.id != null
      );
    },
  },
  beforeRouteEnter: (to, from, next) => {
    // 从制作页返回时保留当前草稿；其它入口先清掉上次编辑的 Vuex，避免先渲染成旧海报
    if (from.name !== "posterBuild") {
      store.commit("posterLong/clearPosterCacheInfo");
    }
    next(async (vm) => {
      await vm.initPage(to, from);
    });
  },
  async beforeRouteUpdate(to, from, next) {
    await this.initPage(to, from);
    next();
  },

  methods: {
    ...mapMutations("posterLong", [
      "updatePosterData",
      "updatePosterTextMaps",
      "clearPosterCacheInfo",
    ]),
    shouldKeepDraft(from) {
      return from && from.name === "posterBuild";
    },
    async initPage(to, from) {
      const schemeId = to.query.schemeId;
      const [logoOptions, contentStyles] = await Promise.all([
        getLogos(),
        getContentStyles(),
      ]);
      this.logoOptions = logoOptions || [];
      this.contentStyles = contentStyles || [];
      this.schemeId = schemeId || "";
      if (this.shouldKeepDraft(from)) {
        return;
      }
      if (schemeId) {
        await this.getDesignDetail(schemeId);
      }
    },
    // 获取用户设计详情
    async getDesignDetail(schemeId) {
      const data = await getPosterLongDetail(schemeId);
      if (!data || !Object.keys(data).length) {
        this.$message.error("获取海报详情失败");
        return;
      }
      data.logos = resolvePosterLogos(data.logos, this.logoOptions);
      data.contentStyle =
        this.contentStyles.find(
          item => Number(item.id) === Number(data.contentStyleId)
        ) || this.contentStyles[0];
      const { posterTextMaps, ...posterData } = data;
      this.updatePosterData(posterData);
      if (Array.isArray(posterTextMaps)) {
        this.updatePosterTextMaps(posterTextMaps);
      }
    },
    // 选中站点
    pickSite(siteId) {
      const selectedLogos = (this.posterData.logos || []).filter(
        item => item && item.id != null
      );
      const logoInfo = this.logoOptions.find(
        item => Number(item.id) === Number(siteId)
      );
      const index = selectedLogos.findIndex(
        item => Number(item.id) === Number(siteId)
      );
      if (index > -1) {
        selectedLogos.splice(index, 1);
      } else if (logoInfo) {
        selectedLogos.push(logoInfo);
      }
      this.updatePosterData({
        logos: [...selectedLogos],
      });
    },
    // 下载并保存
    async downLoad(schemeId) {
      if (this.isDownLoading) return;
      this.isDownLoading = true;
      // 保存到数据库
      savePosterLongToBase(this.posterData, this.posterTextMaps, schemeId);
      const downData = await drawPosterLong(this.posterData, "poster");
      if (downData.result) {
        this.$message({
          message: "下载成功",
          type: "success",
          onClose: () => {
            this.$router.push("/poster/list");
          },
        });
      }
      this.isDownLoading = false;
    },
    // 保存
    async onSave(schemeId = "") {
      if (this.isSaving) return;
      this.isSaving = true;
      let { data, message, code } = await savePosterLongToBase(
        this.posterData,
        this.posterTextMaps,
        schemeId
      );
      if (code === 10000 && data) {
        this.isSaving = false;
        this.$message({
          message: "成功保存到我的设计",
          type: "success",
          onClose: () => {
            this.$router.push("/poster/list");
          },
        });
      } else {
        this.isSaving = false;
        message && this.$message.error(message);
      }
    },
    preStep() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.site-choose {
  height: calc(100% - 120px);
  position: relative;
  width: 100%;
  padding: 20px 320px 20px 20px;
  overflow: auto;
  scrollbar-width: none;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  &::-webkit-scrollbar {
    display: none;
  }
  .poster-wrapper {
    // margin: 35px auto 0 10%;
  }
  .icon-jingshi {
    margin-right: 5px;
    color: #ff6a00;
    font-size: 23px;
  }
  .download_wrap {
    overflow: hidden;
    z-index: -1;
    width: 0;
    height: 0;
  }
}
.choice {
  position: fixed;
  top: 60px;
  bottom: 60px;
  right: 0;
  width: 300px;
  padding: 30px 26px 30px;
  background: #fff;
}
</style>
